/* ============================================================
   MM: Maskenflug - Easter Egg
   Fliegt genau einmal pro Besucher, ausschliesslich auf
   Produktseiten und erst nachdem der Kunde gescrollt hat.
   Oben im Header passiert nichts - dort waere es nur Stoerung.
   ============================================================ */
(function () {
  'use strict';

  var MASK_URL = 'https://cdn.shopify.com/s/files/1/0533/7825/2996/files/Polish-20260618_222355466.png?v=1787340553';

  var SEEN_KEY = 'mm:mask:seen';
  var COUNT_KEY = 'mm:mask:products';
  var CHANCE = 0.45;       /* Wahrscheinlichkeit pro Produktseite */
  var FORCE_AFTER = 3;     /* Spaetestens bei der dritten Produktseite */
  var SCROLL_TRIGGER = 420; /* Erst ab dieser Scrolltiefe in Pixeln */
  var DURATION = 2200;

  if (!MASK_URL) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var forced = new URLSearchParams(location.search).get('mmmask') === '1';

  /* Nur auf Produktseiten */
  var main = document.querySelector('main[data-template]');
  var tpl = main ? (main.getAttribute('data-template') || '') : '';
  if (!forced && tpl.indexOf('product') !== 0) return;

  var store;
  try {
    store = window.localStorage;
    store.setItem('mm:test', '1');
    store.removeItem('mm:test');
  } catch (e) {
    return;
  }

  var shouldFly = false;

  if (forced) {
    shouldFly = true;
  } else if (store.getItem(SEEN_KEY) !== '1') {
    var seen = parseInt(store.getItem(COUNT_KEY) || '0', 10) + 1;
    store.setItem(COUNT_KEY, String(seen));
    if (Math.random() < CHANCE || seen >= FORCE_AFTER) shouldFly = true;
  }

  if (!shouldFly) return;

  function fly() {
    if (!forced) store.setItem(SEEN_KEY, '1');

    var style = document.createElement('style');
    style.textContent = [
      '@keyframes mm-mask-fly {',
      '  0%   { transform: translate3d(-60vw, 12vh, 0) rotate(-14deg) scale(0.85); opacity: 0; }',
      '  12%  { opacity: 1; }',
      '  50%  { transform: translate3d(20vw, -6vh, 0) rotate(4deg) scale(1); }',
      '  88%  { opacity: 1; }',
      '  100% { transform: translate3d(115vw, 8vh, 0) rotate(12deg) scale(0.9); opacity: 0; }',
      '}',
      '.mm-mask-fly {',
      '  position: fixed;',
      '  top: 38%;',
      '  left: 0;',
      '  width: min(46vw, 520px);',
      '  height: auto;',
      '  z-index: 2147483000;',
      '  pointer-events: none;',
      '  will-change: transform, opacity;',
      '  filter: drop-shadow(0 18px 40px rgba(10, 10, 10, 0.45));',
      '  animation: mm-mask-fly ' + DURATION + 'ms cubic-bezier(0.32, 0.06, 0.28, 0.98) forwards;',
      '}',
      '@media (max-width: 749px) {',
      '  .mm-mask-fly { width: 72vw; top: 42%; }',
      '}'
    ].join('\n');
    document.head.appendChild(style);

    var img = document.createElement('img');
    img.src = MASK_URL;
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.className = 'mm-mask-fly';
    document.body.appendChild(img);

    setTimeout(function () {
      img.remove();
      style.remove();
    }, DURATION + 300);
  }

  /* Erst wenn der Kunde tatsaechlich in die Seite eingetaucht ist */
  function waitForScroll() {
    var fired = false;

    function check() {
      if (fired) return;
      if (window.scrollY < SCROLL_TRIGGER) return;
      fired = true;
      window.removeEventListener('scroll', check);
      setTimeout(fly, 500 + Math.random() * 1400);
    }

    window.addEventListener('scroll', check, { passive: true });
    check(); /* Falls die Seite bereits gescrollt geladen wurde */
  }

  function start() {
    var pre = new Image();
    pre.onload = function () {
      if (forced) setTimeout(fly, 600);
      else waitForScroll();
    };
    pre.src = MASK_URL;
  }

  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
